import { GUI } from "dat.gui";
import { Mesh, TextureLoader } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import model from "../../../../../assets/models/subtopicthree/GLB_Monitor_V4.glb";
import { textureAct } from "../../../../../assets/tema6/act";


const textureMaterial = {
	topic5_01: textureAct.topic5.Monitor_5_1,
	topic5_02: textureAct.topic5.Monitor_5_2,
	topic5_03: textureAct.topic5.Monitor_5_3,
}

export class MonitorIntroTopicFive extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);

		this.namesTextures = {
			"topic5_01": "topic5_01",
			"topic5_02": "topic5_02",
			"topic5_03": "topic5_03",
		}

		// const get_key_json = Object.keys(textureMaterial).reduce((acc, key) => {
		// 	acc[key] = key;
		// 	return acc;
		// }, {});
		// this.helpers()
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Monitor = gltf.scene.getObjectByName("Monitor", true);
			this.Pantalla = gltf.scene.getObjectByName("Pantalla", true);
			this.Plano = gltf.scene.getObjectByName("Plano", true);

			this.selectTexture(this.namesTextures.topic5_01);
			this.initMonitor()
		});
	}

	updateMaterialScreen(img) {
		const newTexture = new TextureLoader().load(img);
		const object = this.Plano;
		object.material.map = newTexture
		object.material.toneMapped = false;
	}

	selectTexture(step = "") {
		const img = textureMaterial[step]
		if (!img) {
			return
		}
		this.updateMaterialScreen(img)
	}

	initMonitor() {
		this.position.set(-11.4, -0.226, 2.7)
		this.rotation.y = 1.6
		this.scale.set(2, 2);
		this.Pantalla.scale.set(0.96, 1.2, 0.8) // monitor rectagular
		// this.updateMaterialScreen(imgstopic5.loginSub3Act2);
	}
	helpers() {
		const gui = new GUI();
		const folderMostrador = gui.addFolder("Monitor");
		const limit = 20;
		folderMostrador.add(this.scale, "x", -limit, limit).step(0.0001).name("Ancho");
		folderMostrador.add(this.scale, "y", -limit, limit).step(0.0001).name("Alto");

		folderMostrador.add(this.position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderMostrador.add(this.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderMostrador.add(this.position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folderMostrador.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderMostrador.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderMostrador.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderMostrador.add(this, "visible").name("Visible");

		folderMostrador
			.addColor({ color: this.material.color.getHex() }, "color")
			.name("Color del Material")
			.onChange((value) => {
				this.material.color.set(value);
			});
	}
}
